import api from '../../services/api';
import type { ScreenData } from '../../shared/interfaces/screen';
interface InstructionProps {
  id: string;
  nomeDaInstrucao: string;
  textoDaInstrucao: string;
  listaDeTelas?: ScreenData[] | null;
}

interface InstructionPropsDTO {
  id: string;
  nomeDaInstrucao: string;
  textoDaInstrucao: string;
  listaDeTelas: number[] | null;
}

const PopulateScreens = async (
  instructionDTOs: InstructionPropsDTO[],
): Promise<InstructionProps[]> => {
  const responseScreen = await api.get(`/tela`);

  let instructions: InstructionProps[] = [];
  for (let index = 0; index < instructionDTOs.length; index++) {
    const instructionDTO = instructionDTOs[index];

    let instruction: InstructionProps = {
      id: instructionDTO.id,
      nomeDaInstrucao: instructionDTO.nomeDaInstrucao,
      textoDaInstrucao: instructionDTO.textoDaInstrucao,
    };

    instruction.listaDeTelas = responseScreen.data.filter(
      (s: ScreenData) =>
        instructionDTO &&
        instructionDTO.listaDeTelas &&
        instructionDTO.listaDeTelas.includes(s.id),
    );

    instructions.push(instruction);
  }

  return instructions;
};

export default PopulateScreens;
